var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .box {\n        fill: #f6f8f9;\n        opacity: 0.5;\n      }\n\n      .line {\n        fill: none;\n        stroke: #f6f8f9;\n        stroke-width: 6px;\n      }\n\n      #ticket-red .ticket {\n        fill: #e76f51;\n      }\n\n      #ticket-yellow .ticket {\n        fill: #ffcd67;\n      }\n\n      #ticket-blue .ticket {\n        fill: #3aa8c3;\n      }\n\n      .shadow {\n        filter: url(#shadow);\n      }\n    "), /*#__PURE__*/React.createElement("symbol", {
    id: "ticket-red",
    viewBox: "0 0 1024 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ticket",
    d: "M0 64v128a64 64 0 0164 64 64 64 0 01-64 64v129a64 64 0 0164 63h896a64 64 0 0164-63V321a64 64 0 110-128V64a64 64 0 01-64-64H64A64 64 0 010 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "box",
    d: "M704 64h192v384H704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M128 64h768v384H128zM704 64v384z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ticket-yellow",
    viewBox: "0 0 1024 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ticket",
    d: "M0 64v128a64 64 0 0164 64 64 64 0 01-64 64v129a64 64 0 0164 63h896a64 64 0 0164-63V321a64 64 0 010-128V64a64 64 0 01-64-64H64A64 64 0 010 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "box",
    d: "M704 64h192v384H704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M128 64h768v384H128zM704 64v384z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ticket-blue",
    viewBox: "0 0 1024 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ticket",
    d: "M0 64v128a64 64 0 0164 64 64 64 0 01-64 64v129a64 64 0 0164 63h896a64 64 0 0164-63V321a64 64 0 010-128V64a64 64 0 01-64-64H64A64 64 0 010 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "box",
    d: "M704 64h192v384H704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M128 64h768v384H128zM704 64v384z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("use", {
    width: 1024,
    height: 512,
    transform: "rotate(180 322 501) scale(.57031)",
    xlinkHref: "#ticket-yellow",
    className: "shadow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 1024,
    height: 512,
    transform: "rotate(-149.75 462 423) scale(.73828)",
    xlinkHref: "#ticket-red",
    className: "shadow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 1024,
    height: 512,
    transform: "rotate(-120 615 332) scale(.90625)",
    xlinkHref: "#ticket-blue",
    className: "shadow"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default ForwardRef;